// hooks/useFieldGraphData.ts
import { useEffect, useState, useCallback } from "react";
import { getValueByAreaFields } from "../../services/api";
import { groupDataByField } from "../utils/groupDataByField";
import { Option } from "../interface/interface";
import { capitalize } from "../utils/capitalize";
import { toTitleCase } from "../utils/toTitleCase";

export const useFieldGraphData = (
  areaTag: string,
  selectedFields: Option[] | string,
  startTime: string,
  stopTime: string
) => {
  const [graphData, setGraphData] = useState<Record<string, any[]>>({});
  const [isloading, setIsLoading] = useState<boolean>(false);
  const [rawFieldData, setRawFieldData] = useState<any[]>([]);
  const fetchGraphData = useCallback(async () => {
    if (!areaTag || selectedFields.length === 0) return;
    setIsLoading(true);
    try {
      const fieldNames = Array.isArray(selectedFields)
        ? selectedFields.map((f) => f.value).join(",")
        : selectedFields;
      const response = await getValueByAreaFields(
        areaTag,
        fieldNames,
        `${startTime}`,
        `${stopTime}`
      );
      setRawFieldData(
        (response?.data || []).map((item: any) => ({
          timeStamp: item.timeStamp,
          areaTag: capitalize(areaTag),
          fieldName: toTitleCase(item.fieldName),
          value: item.fieldValue,
        }))
      );
      const grouped = groupDataByField(response?.data);
      setGraphData(grouped);
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [areaTag, selectedFields, startTime, stopTime]);

  useEffect(() => {
    fetchGraphData();
  }, [fetchGraphData]);

  return { graphData, rawFieldData, isloading };
};
